/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ContainmentTypes {
  LadderCableTray = 'Ladder Cable Tray',
  ChannelCableTray = 'Channel Cable Tray',
  WireMeshCableTray = 'Wire Mesh Cable Tray',
  WireWay = 'WireWay',
  BusWay = 'BusWay'
}
